module.exports = __webpack_public_path__ + "static/img/dentaltalk_sm_landscape.69cc5ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/art/dentaltalk_sm_landscape.png
// module id = oN14
// module chunks = 1